<template>
    <div>
        <fade-transition origin="center" mode="out-in" :duration="250">
            <div class="download_app_pop" @click="close" v-if="show">
                <!-- <div class="download_app_content">
                    <p>暂不支持此功能，请前往下载app</p>
                    <div class="icon_download_app">
                        <img :src="require('@/assets/images/icon-download-app@2x.png')" alt="" />
                    </div>
                    <div class="download_btn">
                        <a href="https://a.app.qq.com/o/simple.jsp?pkgname=com.aigupiao.ui">
                            立即下载
                        </a>
                    </div>
                </div> -->

                <div class="download_app_content2">
                    <p>需要前往爱股票app登录才能继续<span>{{ word2 }}</span></p>
                    <div class="download_btn_wrap">
                        <a href="javascript:;" class="download_btn_l">
                            取消
                        </a>
                        <a href="https://a.app.qq.com/o/simple.jsp?pkgname=com.aigupiao.ui" class="download_btn_r">
                            立即跳转
                        </a>
                    </div>
                </div>

            </div>
        </fade-transition>
    </div>
</template>
<script>
import { FadeTransition } from "vue2-transitions";

export default {
    name: 'downapp',
    components: {
        FadeTransition,
    },
    data() {
        return {
            show: false,
            word2:'查看',
        };
    },
    methods: {
        open(word) {
            this.show = true;
            this.word2 = '查看';
            if(typeof word == 'string' && word.length > 0) {
                this.word2 = word;
            }
        },
        close() {
            this.show = false
        }
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.download_app_pop {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .3);

    // .download_app_content {
    //     display: flex;
    //     flex-direction: column;
    //     justify-content: space-between;
    //     align-content: center;
    //     width: 250px;
    //     height: 200px;
    //     background: #ffffff;
    //     border: 0px solid #CACACA;
    //     border-radius: 3px;
    //     padding: 29px 20px 19px;

    //     >p {
    //         text-align: center;
    //         font-size: 14px;
    //         color: #222222;
    //     }

    //     .icon_download_app {
    //         display: flex;
    //         justify-content: center;

    //         >img {
    //             width: 66px;
    //             height: 72px;
    //         }
    //     }

    //     .download_btn {
    //         height: 36px;
    //         background: #FE484A;
    //         border-radius: 3px;
    //         text-align: center;
    //         line-height: 36px;

    //         >a {
    //             display: block;
    //             width: 100%;
    //             height: 100%;
    //             color: #FFFFFF;
    //             font-size: 14px;
    //         }
    //     }

    // }


    .download_app_content2 {

    border-radius: 12px;
    background: #FFF;
    display: flex;
    width: 280px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    }
    .download_app_content2 >p{
    color: #333;
    font-size: 17px;
    padding: 20px 16px;
    line-height: 1.5;
    }
    .download_btn_wrap{
    display: flex;
    width: 100%;
    border-top: 0.5px solid #EBEBEB;
    }
    .download_btn_wrap >a{
    display: flex;
    align-items: center;
    justify-content: center;
    color: #636363;
    font-size: 16px;
    height: 46px;
    width: 50%;
    }

    .download_btn_wrap .download_btn_r{
    color: #FE484A;
    border-left: 0.5px solid #EBEBEB;
    }
}
</style>